import { GET_ALL_NARANJO } from '../../types'

const INITIAL_STATE = {
  getAllNaranjoQuestions: [],
}

const naranjoReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_NARANJO:
      return {
        ...state,
        getAllNaranjoQuestions: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default naranjoReducer
